export default __webpack_public_path__ + "static/media/section3-pic4.050b4b5c.png";